/**
 * Catálogo do domínio `produto` (T53, CAT-02).
 *
 * Origem: `src/shared/autorizacao/produto.ts` — a metade dele. O arquivo
 * imperativo trata `Produto` e `TAF` juntos; são dois domínios do vocabulário, e
 * o TAF ganha arquivo próprio (`taf.ts`).
 */
import type { NomePapel, Papel } from "../catalogo/vocabulario";

export const PAPEIS_PRODUTO = {
  "produto.admin": {
    dominio: "produto",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "Produto" }],
  },
  "produto.escrita": {
    dominio: "produto",
    nivel: "escrita",
    concessoes: [{ acoes: ["read", "update"], recurso: "Produto" }],
  },
  "produto.leitura": {
    dominio: "produto",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "Produto" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
